module.exports = __webpack_public_path__ + "files/3ca2aac4f310979b94e286ac953540ef.png";